import { useRef, useEffect } from "react";

const useFocusableRef = ({ focus }) => {
  const ref = useRef(null);

  useEffect(() => {
    if (focus) {
      ref.current.focus();
    }
  }, [focus]);

  return ref;
};

export default useFocusableRef;
